import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0560509f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-wrap grow" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  style: {"width":"24px","height":"24px","margin-bottom":"2px"},
  class: "text-gray-600 w-4 h-full mx-2 absolute pointer-events-none",
  fill: "transparent",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  stroke: "white"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_VDatePicker = _resolveComponent("VDatePicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_VDatePicker, {
      ref: "cal",
      class: "calendar",
      "is-range": "",
      modelValue: _ctx.range,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.range) = $event))
    }, {
      default: _withCtx(({ inputValue, togglePopover, hidePopover }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_SeButton, {
            class: "grow",
            onClick: _withModifiers(($event: any) => (_ctx.dateSelected($event, _ctx.range, togglePopover)), ["stop"]),
            style: {"display":"flex","justify-content":"center","align-items":"center"},
            ref: "button"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.dateFormat(_ctx.range.start, "dd/mm/yyyy")) + " - " + _toDisplayString(_ctx.dateFormat(_ctx.range.end, "dd/mm/yyyy")) + " ", 1),
                (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
              ])
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}